// lib
import { BrowserRouter, Routes, Route } from "react-router-dom";
// routes components
import SiteRoutes from "./SiteRoutes";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import PrivateRouteDevelopers from "./PrivateRouteDeveloper";
import PublicRouteDevelopers from "./PublicRouteDevelopers";
// hooks
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// redux
import { loginAction, logoutAction } from "../redux/features/auth";
// pages
import Marketplace from "../pages/Marketplace/Marketplace";
import AboutUs from "../pages/About/AboutUs";
// services
// import { checkAuthEndpoint } from '../services/publicService';
import { getAuth, getAuthDeveloper } from "../helpers/authHelper";
import { nextAuthUrl } from "../helpers/nextApi";
import AuthRoutes from "./AuthRoutes";
import TagManager from "react-gtm-module";
import ReactGA from "react-ga";
import Privacy from "../pages/TermsConditions/Privacy";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import NeedHelp from "../pages/FAQ/NeedHelp";
import ReferralsPage from "../pages/Referrals/ReferralsPage";
import GuestVisit from "../pages/GuestVisit/GuestVisit";
import GuestOffer from "../pages/GuestOffer/GuestOffer";
import StepSuccesOffer from "../pages/GuestOffer/components/StepSuccess/StepSuccessOffer";
import StepSuccesVisit from "../pages/GuestVisit/components/StepSuccesVisit/StepSuccesVisit";
import AuthDevsRoutes from "./AuthDevs";
import PrivatesDevsRoutes from "./PrivateDevs";
import PolygonMapHome from "../pages/PolygonMap/PolygonMapHome";

import SelectCountryPage from "../pages/SelectCountry/SelectCountry";
import useUserCountry from "../hooks/useUserCountry";
import axios from "axios";
import Page404 from "../pages/404/404";
import LoadingComponent from "../components/Loading/Loading";
import { setIpAction } from "../redux/features/ip";
import { loginActionDeveloper, logoutActionDev } from "../redux/features/authDeveloper";
import UnauthenticatedPay from "../pages/UnauthenticatedPay/UnauthenticatedPay";
import SuccessPay from "../pages/UnauthenticatedPay/SuccessPay";
import RootLayout from "../layout/layout";
import FailPay from "../pages/UnauthenticatedPay/FailPay";

const AppRouter = () => {
  const { setCountry } = useUserCountry();
  const [checking, setChecking] = useState(true);
  const dispatch = useDispatch();
  const tagManagerArgs = {
    gtmId: "GTM-P3P9TGL",
  };

  // const [ubicacion, setUbicacion] = useState<any>(null);

  // const getGeoCode = async (latitud: any, longitud: any) => {
  //   try {
  //     const response = await axios.get(
  //       `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitud}&lon=${longitud}`
  //     );
  //     const countryCode = response.data.address.country_code;
  //     return countryCode;
  //   } catch (error) {
  //     console.error("Error al obtener el código del país:", error);
  //     return null;
  //   }
  // };

  // // Detect country
  // useEffect(() => {
  //   let url = window.location.pathname;
  //   if (url === "/") {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position: any) => {
  //           setUbicacion(position?.coords);
  //         },
  //         (error) => {
  //           console.error("Error al obtener la ubicación:", error);
  //         }
  //       );
  //     } else {
  //       console.error(
  //         "La geolocalización no está disponible en este navegador."
  //       );
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   if (ubicacion) {
  //     getGeoCode(ubicacion?.latitude, ubicacion?.longitude).then(
  //       (countryCode) => {
  //         if (countryCode) {
  //           if (countryCode === "sv" || countryCode === "gt") {
  //             setCountry(countryCode);
  //             return window.open(`/${countryCode}`, "_self");
  //           } else {
  //             return window.open(`/sv`, "_self");
  //           }
  //         }
  //       }
  //     );
  //   }
  // }, [ubicacion]);

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
    ReactGA.pageview(window.location.pathname + window.location.search);

    let cancelled = false;

    const hydrate = async () => {
      // Country desde la URL (la detección por IP corre después en otro
      // useEffect, no podemos esperarla acá sin demorar el boot).
      const segments = window.location.pathname.split("/").filter(Boolean);
      const fromPath = (segments[0] || "").toLowerCase();
      const fromAppPath = (segments[1] || "").toLowerCase();
      const country = ["sv", "gt", "pa"].includes(fromPath)
        ? fromPath
        : ["sv", "gt", "pa"].includes(fromAppPath)
        ? fromAppPath
        : "sv";

      // 1) Intentar hidratar contra Next (cookies httpOnly de customer).
      try {
        const res = await fetch(nextAuthUrl(country, "session"), {
          credentials: "include",
        });
        if (res.ok) {
          const payload = await res.json();
          const u = payload?.user;
          if (!cancelled && u && (u.realm || u.info?.realm)) {
            dispatch(
              loginAction({
                token: "",
                rft: "",
                name: u.name || u.first_name || "",
                last_name: u.last_name || "",
                avatar: u.avatar || "",
                realm: u.realm || u.info?.realm || "customer",
                realm_roles: u.realm_roles || [],
                is_phone_verified: u.info?.is_phone_verified || false,
              })
            );
            setChecking(false);
            return;
          }
        }
      } catch (err) {
        // Network/CORS error → no hay sesión Next, seguimos con fallback legacy.
        console.warn("Auth session fetch failed, falling back to legacy", err);
      }

      // 2) Fallback legacy: realms no soportados por Next siguen en
      //    localStorage['auth'] (landlord/investor/developer/email-password).
      if (cancelled) return;
      const authDataStorage = getAuth();
      if (authDataStorage) {
        try {
          const authData = JSON.parse(authDataStorage);
          dispatch(loginAction(authData));
        } catch {
          dispatch(logoutAction({}));
        }
      } else {
        dispatch(logoutAction({}));
      }
      setChecking(false);
    };

    hydrate();

    return () => {
      cancelled = true;
    };
  }, [dispatch, setChecking]);

  // Multi-tab logout: Next emite por BroadcastChannel('propi_auth') cuando
  // hace silent logout. Escuchamos para limpiar Redux en otras tabs.
  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return;
    const channel = new BroadcastChannel("propi_auth");
    const onMessage = (event: MessageEvent) => {
      if (event?.data?.type === "logout") {
        dispatch(logoutAction({}));
      }
    };
    channel.addEventListener("message", onMessage);
    return () => {
      channel.removeEventListener("message", onMessage);
      channel.close();
    };
  }, [dispatch]);


  const [countryDetected, setCountryDetected] = useState("");

useEffect(() => {
  // Verificar si el país no está detectado
  axios
    .get(
      "https://ipapi.co/json/?key=aVwg4o2qU83rk8aligqHxIODBDBhViC9WOmGByjMr0Nd96X0O6"
    )
    .then((response) => {
      let data = response.data;
      setCountryDetected(data?.country?.toLowerCase());
      dispatch(setIpAction({ ipClient: data?.ip }));
    })
    .catch((error) => {
      console.log(error);
    });
}, []);

useEffect(() => {
  const urlPath = window.location.pathname;
  const queryParams = window.location.search;

  const pathSegments = urlPath.split("/");
  const countryPath = pathSegments[1];
  const countryPathApp = pathSegments[2];

  const validCountries = ["sv", "gt", "pa"];

  // Si ya hay país en la URL
  if (validCountries.includes(countryPath)) {
    setCountry(countryPath);
    return;
  }

  if (validCountries.includes(countryPathApp)) {
    setCountry(countryPathApp);
    return;
  }

  // Si estamos en la raíz
  if (urlPath === "/" && countryDetected) {

    let redirectCountry = countryDetected;

    // Venezuela y Colombia → Panamá
    if (["ve", "co"].includes(countryDetected)) {
      redirectCountry = "pa";
    }

    // Si no es un país soportado → sv
    if (!validCountries.includes(redirectCountry)) {
      redirectCountry = "sv";
    }

    setCountry(redirectCountry);
    window.open(`/${redirectCountry}${queryParams}`, "_self");
    return;
  }

  // Caso /app sin país
  if (urlPath === "/app/auth/desarrolladoras/login" && countryDetected) {
    window.open(
      `/app/${countryDetected}/auth/desarrolladoras/login${queryParams}`,
      "_self"
    );
  }

}, [countryDetected]);


  // Lista vacía de dependencias para ejecutar el efecto solo una vez

  if (checking) {
    return <LoadingComponent />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RootLayout />}> 
        <Route path="/app/:country" element={<SelectCountryPage />} />
        {/* Marketplace */}
        <Route path="/app/:country/marketplace" element={<Marketplace />} />
        {/* Landings */}
        {/* <Route path="/soy-propietario" element={<OwnerPage />} /> */}
        <Route path="/app/:country/referidos" element={<ReferralsPage />} />
        <Route
          path="/app/:country/politicas-privacidad"
          element={<Privacy />}
        />
        <Route
          path="/app/:country/terminos-condiciones"
          element={<TermsConditions />}
        />
        <Route path="/app/:country/quienes-somos" element={<AboutUs />} />
        <Route path="/app/:country/ayuda" element={<NeedHelp />} />

        {/* Guest Module */}
        <Route
          path="/app/:country/invitado-visitas/*"
          element={
            <PublicRoute>
              <Routes>
                <Route path="/registrarse/:id" element={<GuestVisit />} />
                <Route
                  path="/registrarse/exito"
                  element={<StepSuccesVisit />}
                />
              </Routes>
            </PublicRoute>
          }
        />
        <Route
          path="/app/:country/invitado-oferta/*"
          element={
            <PublicRoute>
              <Routes>
                <Route
                  path="/registrarse/:propertyId"
                  element={<GuestOffer />}
                />
                <Route
                  path="/registrarse/exito"
                  element={<StepSuccesOffer />}
                />
              </Routes>
            </PublicRoute>
          }
        />

        {/* Public routes */}
        <Route
          path="/app/:country/auth/*"
          element={
            <PublicRoute>
              <AuthRoutes />
            </PublicRoute>
          }
        />

        <Route
          path="/app/:country/auth/desarrolladoras/*"
          element={
            <PublicRouteDevelopers>
              <AuthDevsRoutes />
            </PublicRouteDevelopers>
          }
        />

        <Route
          path="/app/:country/desarrolladoras/*"
          element={
            <PrivateRouteDevelopers>
              <PrivatesDevsRoutes />
            </PrivateRouteDevelopers>
          }
        />

        {/* Private routes */}
        <Route
          path="/app/:country/l/*"
          element={
            <PrivateRoute>
              <SiteRoutes />
            </PrivateRoute>
          }
        />

        {/* Desarrolladoras */}

        {/* Polygon Map */}
        <Route path="/app/:country/polygons" element={<PolygonMapHome />} />

        <Route path="/app/:country/pago-rapido/exito" element={<SuccessPay />} />
        <Route path="/app/:country/pago-rapido/error" element={<FailPay />} />
        <Route path="/app/:country/pago-rapido/:transaction_id" element={<UnauthenticatedPay />} />
        
        <Route path="/:country/*" element={<Page404 />} />
        </Route>
       
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
